// SEC-128: the access token lives in an HttpOnly cookie JavaScript cannot read,
// so the client keeps no token — only a non-sensitive expiry hint (epoch
// seconds) in module memory to drive proactive refresh. A page load re-seeds it
// from `GET /auth/me` or the next `/auth/refresh`.

let expiresAt: number | null = null;

export function setSessionExpiry(epochSeconds: number): void {
  expiresAt = epochSeconds;
}

export function getSessionExpiry(): number | null {
  return expiresAt;
}

export function clearSession(): void {
  expiresAt = null;
}

// A null expiry counts as "expiring" so callers refresh to establish one.
export function isExpiringWithin(bufferSec: number): boolean {
  if (expiresAt === null) return true;
  const nowSec = Math.floor(Date.now() / 1000);
  return expiresAt <= nowSec + bufferSec;
}
